import { Availability } from '@luminovo/api-contracts';
import { Comparable, compareByNumber } from '@luminovo/commons';

import { leadTimeDaysExtractor } from '../extractors';

export function compareByAvailability<T>(
    extractAvailability: (item: T) => Availability | null | undefined,
): Comparable<T> {
    return compareByNumber((item) => {
        const availability = extractAvailability(item);
        if (availability === null || availability === undefined) {
            return -Infinity;
        }
        return leadTimeDaysExtractor(availability);
    });
}
